/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidGuidFilterItemOutputIEnumerableKeyValuePair,
    GuidGuidFilterItemOutputIEnumerableKeyValuePairFromJSON,
    GuidGuidFilterItemOutputIEnumerableKeyValuePairFromJSONTyped,
    GuidGuidFilterItemOutputIEnumerableKeyValuePairToJSON,
} from './';

/**
 * 
 * @export
 * @interface GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutput
 */
export interface GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutput {
    /**
     * 
     * @type {string}
     * @memberof GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutput
     */
    displayText?: string | null;
    /**
     * 
     * @type {GuidGuidFilterItemOutputIEnumerableKeyValuePair}
     * @memberof GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutput
     */
    value?: GuidGuidFilterItemOutputIEnumerableKeyValuePair;
    /**
     * 
     * @type {boolean}
     * @memberof GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutput
     */
    isEffective?: boolean;
}

export function GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutputFromJSON(json: any): GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutput {
    return GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutputFromJSONTyped(json, false);
}

export function GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'value': !exists(json, 'value') ? undefined : GuidGuidFilterItemOutputIEnumerableKeyValuePairFromJSON(json['value']),
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
    };
}

export function GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutputToJSON(value?: GuidGuidFilterItemOutputIEnumerableKeyValuePairFilterItemOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayText': value.displayText,
        'value': GuidGuidFilterItemOutputIEnumerableKeyValuePairToJSON(value.value),
        'isEffective': value.isEffective,
    };
}


